const makeExtendedData = (data = []) => {
  const extendedData = data.map(item => ({
    ...item,
    fullName: item.fullName || `${item.fristName || item.firstName || ''} ${item.lastName || ''}`.trim(),
  }));
  return extendedData;
};

export default makeExtendedData;
